// extracted by mini-css-extract-plugin
export var acceptButton = "_18-5";
export var fullContent = "_18-4";
export var link = "_18-6";
export var linkIcon = "_18-7";
export var sideContent = "_18-3";
export var sideImage = "_18-2";
export var sideImageWrapper = "_18-1";
export var splitLayout = "_18-0";